<notifier-container></notifier-container>

<div class="card">
  <p class="card-title">Novo Cadastro - <span>{{policyName}}</span></p>
  <div *ngFor="let attribute of sections">
    <app-section 
      [attribute]="attribute"
      [currentStep]="currentStep"
      (onEmit)="onSectionEmit($event)">
    </app-section>
  </div>
</div>